<template>
    <div>
        <b-card class="m-0" no-body>
            <b-card-header
                class="d-flex justify-content-between align-items-center"
            >
                <h5 class="modal-title">Transfer Dana Antar Gudang</h5>
            </b-card-header>
            <b-card-body v-show="isKonfirmasi">
                <p>
                    Transfer dana sebesar Rp. {{ formatNumber(form.nominal) }}
                </p>
                <p class="mb-2">Detail transfer:</p>
                <div class="card mb-3">
                    <div class="card-body">
                        <h6 class="card-subtitle mb-2 text-muted">
                            Gudang Asal
                        </h6>
                        <p class="card-text">{{ gudang ? gudang.name : "" }}</p>
                        <p class="card-text">
                            Saldo saat ini: Rp.
                            {{
                                formatNumberStrict(
                                    gudang ? gudang.saldo_rekening_gudang : 0
                                )
                            }}
                        </p>
                        <p class="card-text">
                            Saldo setelah transfer: Rp.
                            {{
                                formatNumberStrict(
                                    parseInt(
                                        gudang
                                            ? gudang.saldo_rekening_gudang
                                            : 0
                                    ) - parseInt(form.nominal)
                                )
                            }}
                        </p>
                    </div>
                </div>
                <div class="card">
                    <div class="card-body">
                        <h6 class="card-subtitle mb-2 text-muted">
                            Gudang Tujuan
                        </h6>
                        <p class="card-text">
                            {{
                                form.gudangTujuan ? form.gudangTujuan.name : ""
                            }}
                        </p>
                        <p class="card-text">
                            Saldo saat ini: Rp.
                            {{
                                formatNumberStrict(
                                    form.gudangTujuan
                                        ? form.gudangTujuan
                                              .saldo_rekening_gudang
                                        : 0
                                )
                            }}
                        </p>
                        <p class="card-text">
                            Saldo setelah transfer: Rp.
                            {{
                                formatNumberStrict(
                                    parseInt(
                                        form.gudangTujuan
                                            ? form.gudangTujuan
                                                  .saldo_rekening_gudang
                                            : 0
                                    ) + parseInt(form.nominal)
                                )
                            }}
                        </p>
                    </div>
                </div>
            </b-card-body>
            <b-card-body v-show="!isKonfirmasi">
                <div class="form-group" v-if="!gudang">
                    <label class="form-control-label">Gudang Asal</label>
                    <div class="input-group mb-0">
                        <multiselect
                            class="w-auto flex-grow-1"
                            v-validate="'required'"
                            name="gudang"
                            v-model="gudang"
                            :options="allGudangs"
                            :placeholder="'Pilih gudang asal'"
                            :searchable="true"
                            label="name"
                            track-by="id"
                            :allowEmpty="false"
                            :show-labels="false"
                        ></multiselect>
                    </div>
                    <span class="text-danger">{{
                        errors.first("gudang")
                    }}</span>
                    <div class="mt-2" v-if="gudang">
                        <strong>Saldo Gudang Asal:</strong> Rp.
                        {{ formatNumberStrict(gudang.saldo_rekening_gudang) }}
                    </div>
                </div>

                <div class="form-group">
                    <label class="form-control-label">Gudang Tujuan</label>
                    <div class="input-group mb-0">
                        <multiselect
                            class="w-auto flex-grow-1"
                            v-validate="'required'"
                            name="gudangTujuan"
                            v-model="form.gudangTujuan"
                            :options="gudangTujuanOptions"
                            :placeholder="'Pilih gudang tujuan'"
                            :searchable="true"
                            label="name"
                            track-by="id"
                            :allowEmpty="false"
                            :show-labels="false"
                        ></multiselect>
                    </div>
                    <span class="text-danger">{{
                        errors.first("gudangTujuan")
                    }}</span>
                    <div class="mt-2" v-if="form.gudangTujuan">
                        <strong>Saldo Gudang Tujuan:</strong> Rp.
                        {{
                            formatNumberStrict(
                                form.gudangTujuan.saldo_rekening_gudang
                            )
                        }}
                    </div>
                </div>

                <div class="form-group">
                    <label>Nominal Transfer</label>
                    <input
                        v-validate="'required|min:0'"
                        min="0"
                        v-model="form.nominal"
                        type="number"
                        name="nominal"
                        class="form-control"
                    />
                    <span class="text-danger">{{
                        errors.first("nominal")
                    }}</span>
                </div>

                <div class="form-group">
                    <label>Keterangan</label>
                    <input
                        v-model="form.notes"
                        type="text"
                        name="notes"
                        class="form-control"
                    />
                    <span class="text-danger">{{ errors.first("notes") }}</span>
                </div>
            </b-card-body>
            <b-card-footer class="d-flex flex-row-reverse">
                <template v-if="isKonfirmasi">
                    <button
                        :disabled="isLoading"
                        @click="koreksi"
                        type="button"
                        class="btn btn-secondary"
                    >
                        Koreksi
                    </button>
                    <button
                        :disabled="isLoading"
                        @click="save"
                        type="button"
                        class="btn btn-primary mr-2"
                    >
                        OK
                    </button>
                </template>
                <template v-else>
                    <button
                        :disabled="isLoading"
                        @click="$emit('cancel')"
                        type="button"
                        class="btn btn-secondary"
                        data-dismiss="modal"
                    >
                        Batal
                    </button>
                    <button
                        :disabled="isLoading"
                        @click="konfirmasi"
                        type="button"
                        class="btn btn-primary mr-2"
                    >
                        Simpan
                    </button>
                </template>
            </b-card-footer>
        </b-card>
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
    name: "transfer-dana-gudang-form",

    props: {
        gudang: {
            type: Object,
            default: () => {},
        },
        isPenarikan: {
            type: Boolean,
            default: false,
        },
        initialTransferData: {
            type: Object,
            default: null,
        },
    },

    components: {
        Multiselect,
    },

    data() {
        return {
            form: {
                nominal: null,
                notes: null,
                gudangTujuan: null,
            },
            allGudangs: [], // Semua gudang tersedia di sini
            isKonfirmasi: false,
            isLoading: false,
        };
    },

    created() {
        this.resetForm();

        // Inisialisasi form dengan data transfer jika ada
        if (this.initialTransferData) {
            this.form.gudangTujuan = this.initialTransferData.gudangTujuan;
            this.form.nominal = this.initialTransferData.nominal;
            this.form.notes = this.initialTransferData.notes;
        }
    },

    mounted() {
        this.resetForm();
        this.loadAllGudangs();
    },

    computed: {
        // Filter gudangTujuanOptions untuk tidak menampilkan gudang asal
        gudangTujuanOptions() {
            if (!this.gudang) {
                return this.allGudangs;
            }
            return this.allGudangs.filter((g) => g.id !== this.gudang.id);
        },
    },

    methods: {
        resetForm() {
            this.form = Object.assign(
                {},
                {
                    nominal: null,
                    notes: null,
                    gudangTujuan: null,
                }
            );

            if (this.value) {
                this.form.nominal = this.value.nominal;
                this.form.notes = this.value.notes;
                this.form.gudangTujuan = this.value.gudangTujuan;
            }
        },

        konfirmasi() {
            let self = this;

            if (self.value) {
                self.save();
                return;
            }

            self.$validator.validateAll().then((result) => {
                if (result) {
                    // Make sure gudang asal dan tujuan tidak sama
                    if (
                        self.gudang &&
                        self.form.gudangTujuan &&
                        self.gudang.id === self.form.gudangTujuan.id
                    ) {
                        Toast.fire({
                            icon: "error",
                            title: "Gudang asal dan tujuan tidak boleh sama",
                        });
                        return;
                    }

                    // Make sure saldo cukup - PERBAIKAN: Menambahkan operator < yang hilang
                    if (
                        self.gudang &&
                        parseInt(self.gudang.saldo_rekening_gudang) <
                            parseInt(self.form.nominal)
                    ) {
                        Toast.fire({
                            icon: "error",
                            title: "Saldo gudang asal tidak mencukupi untuk transfer",
                        });
                        return;
                    }

                    self.isKonfirmasi = true;
                }
            });
        },

        koreksi() {
            this.isKonfirmasi = false;
        },

        save() {
            let self = this;

            self.isLoading = true;
            let data = {
                gudang_asal_id: self.gudang ? self.gudang.id : null,
                gudang_tujuan_id: self.form.gudangTujuan
                    ? self.form.gudangTujuan.id
                    : null,
                nominal: self.form.nominal,
                notes: self.form.notes,
            };

            let api = self.value
                ? "/api/transfer-gudangs/" + self.value.id
                : "/api/transfer-gudangs";

            self.$Progress.start();
            axios({
                method: self.value ? "put" : "post",
                url: api,
                data: data,
            })
                .then(function (response) {
                    Toast.fire({
                        icon: "success",
                        title: response.data.message,
                    });
                    self.isLoading = false;
                    self.$Progress.finish();
                    self.$emit("saved", response.data.data);
                })
                .catch(function (error) {
                    self.isLoading = false;
                    self.$Progress.finish();
                    self.requestFailed(error);
                });
        },

        loadAllGudangs() {
            let self = this;

            self.isLoading = true;
            console.log("Loading gudangs...");

            // Gunakan endpoint all-gudangs
            axios({
                method: "get",
                url: "/api/transfer-gudangs/all-gudangs",
                headers: {
                    "Cache-Control": "no-cache",
                },
            })
                .then(function (response) {
                    self.isLoading = false;
                    console.log("Response from API:", response.data);

                    // Log struktur data untuk debugging
                    if (response.data) {
                        console.log("Response structure:", {
                            hasData: response.data.hasOwnProperty("data"),
                            dataType: response.data.data
                                ? typeof response.data.data
                                : "undefined",
                            isArray: response.data.data
                                ? Array.isArray(response.data.data)
                                : false,
                        });
                    }

                    // Cek berbagai kemungkinan struktur data
                    if (response.data && response.data.data) {
                        // Format: { data: [...], message: "..." }
                        self.allGudangs = response.data.data;
                    } else if (response.data && Array.isArray(response.data)) {
                        // Format: [...] (array langsung)
                        self.allGudangs = response.data;
                    } else if (
                        response.data &&
                        typeof response.data === "object"
                    ) {
                        // Format: objek dengan properti yang mungkin berisi gudangs
                        // Coba deteksi array gudang
                        for (const key in response.data) {
                            if (Array.isArray(response.data[key])) {
                                const candidateArray = response.data[key];
                                // Periksa apakah ini array gudang (memiliki properti name, id, dll)
                                if (
                                    candidateArray.length > 0 &&
                                    candidateArray[0].hasOwnProperty("name")
                                ) {
                                    self.allGudangs = candidateArray;
                                    break;
                                }
                            }
                        }
                    }

                    console.log("Loaded gudangs:", self.allGudangs.length);

                    // Jika masih tidak ada data, coba endpoint regular
                    if (!self.allGudangs || self.allGudangs.length === 0) {
                        self.loadFromRegularEndpoint();
                    }
                })
                .catch(function (error) {
                    console.error("Error loading gudangs:", error);
                    self.loadFromRegularEndpoint();
                });
        },

        loadFromRegularEndpoint() {
            let self = this;

            console.log("Trying regular gudangs endpoint...");
            axios({
                method: "get",
                url: "/api/gudangs",
                params: {
                    per_page: 1000,
                },
                headers: {
                    "Cache-Control": "no-cache",
                },
            })
                .then(function (response) {
                    self.isLoading = false;
                    console.log("Response from regular API:", response.data);

                    if (response.data && response.data.data) {
                        self.allGudangs = response.data.data;
                        console.log(
                            "Loaded gudangs from regular endpoint:",
                            self.allGudangs.length
                        );
                    }
                })
                .catch(function (error) {
                    self.isLoading = false;
                    console.error(
                        "Error loading gudangs from regular endpoint:",
                        error
                    );
                    self.requestFailed(error);
                });
        },
    },
};
</script>
